import React from 'react'
import FooterColumnHead from './FooterColumnHead'
import FooterColumnContent from './FooterColumnContent'

const FooterColumn = props => {
  return (
    <div className="col col-12 col-xl-3 float-md-left">
      <FooterColumnHead isHidden={props.column.rows.isHidden} title={props.column.head.title} expandClickHandler={props.expandClickHandler} uid={props.column.uid} />
      <FooterColumnContent isHidden={props.column.rows.isHidden} rows={props.column.rows.values} />
    </div>
  )
}

export default FooterColumn